export const reportStyles = {
  containerMarginStyles: { marginLeft: "20px", marginTop: "-30px" },
  paperStyles: { p: 3, mb: 4 },
  body1Styles: { mx: 1, display: { xs: "none", sm: "block" } },
  statckStyles: { bgcolor: "#06214b", color: "#fff" },
  chartSectionPaperStyles: { mb: 4, overflow: "hidden" },
  chartSectionBoxStyles: {
    backgroundColor: "#ccc",
    borderRadius: "5px",
    display: "flex",
    gap: { xs: "2px", sm: "8px" },
    justifyContent: "flex-end",
  },
  chartSectionTypographyStyles: { fontSize: { xs: "1rem", sm: "1.25rem" } },
  displayStyles: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: "20px", sm: "40px", md: "60px" },
    mb: 3,
  },
  paddingLeft: {
    paddingLeft: { xs: "5px", sm: "20px" },
  },
  display: {
    display: "flex",
  },
  reportImageStyles: { backgroundColor: "white", height: "30px" },
  avatarBackgroundColor: { backgroundColor: "white" },
  perfectScrollBarBoxStyles: { height: "400px", px: 2, pb: 4 },
  tablePaperStyles: { mb: 4 },
  tableTypographyColor: { color: "#042b69" },
  buttonStyles: {
    bgcolor: "#06214b",
    color: "white",
    borderRadius: "10px",
    fontSize: "10px",
  },
  customGridStyles: {
    marginLeft: "20px !important",
    "& .MuiDataGrid-cell:hover": {
      cursor: "pointer",
    },
  },
  avatarBackGroundColor: { backgroundColor: "white" },
  bottleColor: { backgroundColor: "white", height: "30px" },
  pageNoBacgroundColor: { backgroundColor: "#e3e4eb", display: "flex" },
  pageNoColor: { color: "#06214b" },
  startIconSize: { fontSize: "10px" },
  keyboardIconSize: { fontSize: "10px" },
};

export const reportAdminModalStyles = {
  barModalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 900,
    height: "80vh",
    maxHeight: 700,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    outline: "none",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  wholesalerModalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 900,
    height: "80vh",
    maxHeight: 700,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    outline: "none",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  wholesalerHeaderBox: {
    p: 3,
    pb: 2,
    bgcolor: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 2,
  },
  wholesalerHeaderBoxLine: { mb: 1.5, lineHeight: 1.2 },
  headerBoxDisplay: { display: "flex", alignItems: "center", gap: 1, mb: 0.5 },
  iconStyle: { color: "#0056d2", fontSize: 20 },
  headerBoxTextTransform: {
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  chipStyle: {
    bgcolor: "#0056d2",
    color: "white",
    fontWeight: 600,
    fontSize: "0.875rem",
    height: "32px",
    borderRadius: "16px",
    "& .MuiChip-label": {
      px: 2,
    },
    maxWidth: "100%",
    "& .MuiChip-label": {
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      px: 2,
    },
  },
  closeIcon: {
    color: "text.secondary",
    mt: 0.5,
    "&:hover": {
      bgcolor: "rgba(0, 0, 0, 0.04)",
    },
  },
  contentBoxStyle: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  tableContainer: {
    flex: 1,
    overflow: "auto",
    "&::-webkit-scrollbar": { width: "8px", height: "8px" },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "4px",
      "&:hover": { background: "#a8a8a8" },
    },
  },
  tableStyle: {
    bgcolor: "#f8fafc",
    fontWeight: 600,
    color: "#044286",
    borderBottom: "2px solid #e2e8f0",
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  tableBodyRow: {
    "&:nth-of-type(odd)": { bgcolor: "#fafbfc" },
    "&:hover": {
      bgcolor: "#f1f5f9",
      transition: "background-color 0.2s ease",
    },
    "& td": { borderBottom: "1px solid #f1f5f9", py: 2 },
  },
  tableCellMonth: {
    bgcolor: "#dbeafe",
    color: "#1e40af",
    px: 2,
    py: 0.5,
    borderRadius: 2,
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  tableCellWeek: {
    bgcolor: "#fef3c7",
    color: "#92400e",
    px: 2,
    py: 0.5,
    borderRadius: 2,
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  fontWeight: { fontWeight: 500 },
  tableCellBrand: {
    bgcolor: "#dbeafe",
    color: "#1e40af",
    px: 2,
    py: 0.5,
    borderRadius: 2,
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  tableCellStyles: {
    py: 6,
    color: "text.secondary",
    fontStyle: "italic",
  },
  wholesalerHeaderBoxFlex: { flex: 1, minWidth: 0 },
};

export const adminDashboardStyles = {
  dashboardCardPaper: { p: 2 },
  metricsStyles: { color: "#fff", fontWeight: "bold" },
  metricsStyles1: { color: "#4CAF50", fontWeight: "bold" },
  iconStyles: { fontSize: 30, color: "#2f4cdd" },
  dashboard: {
    p: 3,
    minHeight: "100vh",
    marginLeft: "15px",
    marginTop: "-25px",
  },
  headingStyles: { marginBottom: 2, marginLeft: "7px" },
  metricsPaper: {
    p: 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: 3,
    height: 150,
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.03)",
    },
  },
  wholesalerTablePaper: {
    p: 2,
    mb: 3,
    height: 360,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
  wholesalerTableTypography: { color: "#4661e7e8" },
  tableHead: { backgroundColor: "#2f4cdde3" },
  tableCell: {
    fontWeight: "bold",
    color: "#fff",
  },
  tableStyle: { textAlign: "center", color: "gray" },
  alcoholPaper: {
    p: 3,
    mb: 5,
    height: 360,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
  typographyColor: { color: "#4661e7e8" },
  salesChartPaper: { p: 2, mb: 5 },
  salesChartTypography: { color: "#4661e7e8", mb: 4 },
  barTablePaper: {
    p: 2,
    mb: 3,
    height: 400,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  salesChartPaper: { p: 2, mb: 5 },
  customerTablePaper: {
    p: 2,
    mb: 3,
    height: 400,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
  transactions: { p: 2, mb: 5 },
  transactionsCell: {
    textAlign: "center",
    fontWeight: "bold",
    borderRadius: "8px",
    padding: "4px 8px",
  },
  statusLabel: {
    color: "#fff",
    px: 2,
    py: 0.5,
    borderRadius: "12px",
    display: "inline-block",
    fontWeight: "bold",
    fontSize: "0.875rem",
  },
};

export const wholesalerDashboardStyles = {
  dashboardHeading: {
    bgcolor: "#f9f9f9",
    minHeight: "100vh",
    p: 4,
    marginTop: "-34px",
  },
  headingTableDashboard: { marginBottom: 2, marginLeft: "7px" },
  salesPaper: { p: 3, maxHeight: "400px", overflow: "auto" },
  salesTypography: {
    p: 1,
    borderRadius: "5px",
    fontWeight: "bold",
  },
  productPaper: {
    p: 3,
    height: "400px",
    display: "flex",
    flexDirection: "column",
  },
  producTypography: {
    p: 1,
    borderRadius: "5px",
    fontWeight: "bold",
  },
  productFlex: {
    overflowY: "auto",
    flexGrow: 1,
    pr: 1,
  },
  listPaper: {
    p: 2,
    mb: 3,
    height: 400,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },
  listProductsPaper: {
    p: 2,
    mb: 3,
    height: "auto",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
  },

  listTypographyColor: { color: "#7894F7" },
  listTableHead: { backgroundColor: "#3182ce" },
  listTableCell: { fontWeight: "bold", color: "#fff" },
  listTableRow: { textAlign: "center", color: "gray" },
};
